import { AnyHash, NameableInterface, Uuid } from '@hidat/huijs-common';
import { ResourceConfig } from '@hidat/huijs-resource';

export const UserConfig: ResourceConfig = new ResourceConfig(
  'User',
  'users',
  false,
  true,
);

export interface UserInterface extends NameableInterface {
  id: Uuid | undefined;
  email: string | undefined | null;
  emailConfig: AnyHash | undefined;
  externalId: string | undefined | null;
  currentStationId: number | undefined | null;
  createdAt: unknown | undefined;
  updatedAt: unknown | undefined;
  avatarUrl?: string | undefined;
}
